"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMatureHeightMeters = exports.getMixedSpeciesName = exports.getTreeSpecie = exports.getPredominantSpecies = exports.getETSSpecies = exports.getETSSpeciesName = exports.isCustomSpecies = void 0;
const forest_type_1 = require("../tupuake/properties/forest_type");
const carboncrop_species_1 = require("./carboncrop-species");
const predominant_species_1 = require("../tupuake/properties/predominant_species");
const tree_species_1 = require("../tupuake/properties/tree_species");
const isCustomSpecies = (species) => !!species.startsWith('custom:');
exports.isCustomSpecies = isCustomSpecies;
const getETSSpeciesName = (species) => { var _a; return ((_a = forest_type_1.forest_types.find((sp) => sp.key === species)) === null || _a === void 0 ? void 0 : _a.display_name) || ''; };
exports.getETSSpeciesName = getETSSpeciesName;
const getETSSpecies = (species) => {
    var _a, _b, _c;
    return ((_a = forest_type_1.forest_types.find((sp) => sp.key === species)) === null || _a === void 0 ? void 0 : _a.key) ||
        ((_b = predominant_species_1.predominant_species.find((spec) => spec.key === species)) === null || _b === void 0 ? void 0 : _b.ets_species_key) ||
        ((_c = predominant_species_1.predominant_species.find((spec) => { var _a; return spec.key === ((_a = tree_species_1.tree_species.find((spec) => spec.key === species)) === null || _a === void 0 ? void 0 : _a.predominant_species_key); })) === null || _c === void 0 ? void 0 : _c.ets_species_key);
};
exports.getETSSpecies = getETSSpecies;
const getPredominantSpecies = (species) => {
    var _a, _b;
    const tree_species_result = (_a = tree_species_1.tree_species.find((spec) => spec.key === species)) === null || _a === void 0 ? void 0 : _a.predominant_species_key;
    if (tree_species_result) {
        return tree_species_result;
    }
    const predominant_species_result = predominant_species_1.predominant_species_list.find((sp) => sp === species);
    if (predominant_species_result) {
        return predominant_species_result;
    }
    const etsSpeciesResult = predominant_species_1.predominant_species.filter((spec) => spec.ets_species_key === species);
    if (etsSpeciesResult.length === 1) {
        return (_b = etsSpeciesResult[0]) === null || _b === void 0 ? void 0 : _b.key;
    }
    return undefined;
};
exports.getPredominantSpecies = getPredominantSpecies;
const getTreeSpecie = (species) => {
    var _a;
    if (!tree_species_1.tree_species_list.includes(species)) {
        const predominant = (0, exports.getPredominantSpecies)(species);
        const result_predominant_and_ets_species = tree_species_1.tree_species.filter((spec) => spec.predominant_species_key === predominant);
        if (result_predominant_and_ets_species.length > 1) {
            return undefined;
        }
        return (_a = result_predominant_and_ets_species[0]) === null || _a === void 0 ? void 0 : _a.key;
    }
    return tree_species_1.tree_species_list.find((sp) => sp === species);
};
exports.getTreeSpecie = getTreeSpecie;
// Get display name for mixed species: TreeSpeciesKey | PredominantSpeciesKey | CarbonCropSpeciesKey
const getMixedSpeciesName = (species) => {
    var _a;
    if (species === undefined) {
        return undefined;
    }
    return (_a = [...tree_species_1.tree_species, ...predominant_species_1.predominant_species, ...carboncrop_species_1.carboncrop_species, ...forest_type_1.forest_types].find((sp) => sp.key === species)) === null || _a === void 0 ? void 0 : _a.display_name;
};
exports.getMixedSpeciesName = getMixedSpeciesName;
const getMatureHeightMeters = (species) => {
    var _a, _b;
    const predominant_species_result = tree_species_1.tree_species.filter((f) => f.predominant_species_key === species);
    if (predominant_species_result.length > 1) {
        const height = predominant_species_result[0].mature_height_meters;
        for (let i = 1; i < predominant_species_result.length; i += 1) {
            if (predominant_species_result[i].mature_height_meters !== height) {
                return undefined;
            }
        }
    }
    return (((_a = predominant_species_result[0]) === null || _a === void 0 ? void 0 : _a.mature_height_meters) ||
        ((_b = tree_species_1.tree_species.find((f) => f.key === species)) === null || _b === void 0 ? void 0 : _b.mature_height_meters));
};
exports.getMatureHeightMeters = getMatureHeightMeters;
